var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useScrollFromAnchor } from '@bfa/nextjs-common/hooks';
import React from 'react';
import Error from '../../../components/Error';
import Loading from '../../../components/Loading';
import DetailedNextShipmentSummary from './components/DetailedNextShipmentSummary';
import OnboardingTour from './components/OnboardingTour';
import SubscribedBannerSection from './components/SubscribedBannerSection';
import UpsellByCategories from './components/UpsellByCategories';
import useOnboarding from './useOnboarding';
import useSubscribedLanding from './useSubscribedLanding';
var SubscribedLanding = function () {
    var _a;
    var _b = useSubscribedLanding(), loading = _b.loading, error = _b.error, setAddItemMessage = _b.setAddItemMessage, subscribedCarouselSectionContent = _b.subscribedCarouselSectionContent, subscription = _b.subscription, onboardingTourContent = _b.onboardingTourContent, shouldUserSeePaymentFailurePage = _b.shouldUserSeePaymentFailurePage;
    var showOnboarding = useOnboarding().showOnboarding;
    var _c = __read(useScrollFromAnchor('SuperstarSectionTabs', 'smooth'), 1), scrollSuperStarRef = _c[0];
    if (loading || shouldUserSeePaymentFailurePage) {
        return React.createElement(Loading, null);
    }
    if ((error === null || error === void 0 ? void 0 : error.networkError) || !subscription) {
        return React.createElement(Error, null);
    }
    return (React.createElement("div", null,
        React.createElement(SubscribedBannerSection, { slides: (_a = subscribedCarouselSectionContent === null || subscribedCarouselSectionContent === void 0 ? void 0 : subscribedCarouselSectionContent.slides) !== null && _a !== void 0 ? _a : [] }),
        React.createElement("div", { ref: scrollSuperStarRef },
            React.createElement(DetailedNextShipmentSummary, null)),
        React.createElement(UpsellByCategories, { subscription: subscription, setAddItemMessage: setAddItemMessage }),
        onboardingTourContent && (React.createElement(OnboardingTour, { content: onboardingTourContent, isOpen: showOnboarding }))));
};
export default SubscribedLanding;
